import {Component, Inject} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {PrescriptionService} from "@core/http/table-data-services/prescription.service";
import {MatIcon} from "@angular/material/icon";
import {HttpErrorResponse} from "@angular/common/http";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";

export interface QrData {
  id: string
}

@Component({
  selector: 'app-prescription-qr',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIcon,
  ],
  templateUrl: './prescription-qr.component.html',
  styleUrl: './prescription-qr.component.scss'
})
export class PrescriptionQrComponent {
  qrCode: string = '';

  constructor(
    public dialogRef: MatDialogRef<PrescriptionQrComponent>,
    private service: PrescriptionService,
    private httpMsgHandler: HttpMesageHandlerService,
    @Inject(MAT_DIALOG_DATA) public data: QrData
  ) {

    this.service.getQr(data.id).subscribe({
      next: (value) => {
        this.qrCode = value.data
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    })
  }

}
